module.exports = __webpack_public_path__ + "static/media/Home-X-03.c67bcdbb.png";